import { render, staticRenderFns } from "./ItemsTick.vue?vue&type=template&id=6110a3ea&scoped=true&lang=pug&"
import script from "./ItemsTick.vue?vue&type=script&lang=ts&"
export * from "./ItemsTick.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsTick.vue?vue&type=style&index=0&id=6110a3ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6110a3ea",
  null
  
)

export default component.exports